import { Dialog } from "@/components/shared/dialog";
import { Card, Flex, Separator, Text, Badge, Button } from "@radix-ui/themes";
import { EnvelopeClosedIcon, FileTextIcon } from "@radix-ui/react-icons";

import styles from "./styles.module.scss";
import { toast } from "sonner";

import { useForgetFeedback } from "../chat/api";
import { useWorkspace } from "../context/wrokspace";

export const MessageSources = ({
  isOpen,
  setOpen,
  sources,
  disableForgetIt = false,
}: {
  isOpen: boolean;
  setOpen: (value: React.SetStateAction<boolean>) => void;
  sources: any[] | null;
  disableForgetIt?: boolean;
}) => {
  const { mutateAsync: forgetFeedback } = useForgetFeedback();
  const { workspace } = useWorkspace();

  if (!sources) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={(v) => setOpen(v)}>
      <Dialog.Content size={"large"}>
        <Dialog.Close className={styles.Close} />
        <Dialog.Title>List of sources reviewed before answering</Dialog.Title>
        <div className={styles.SourceDialogList}>
          {sources &&
            Array.isArray(sources) &&
            sources?.map((s) => {
              if (!s) {
                return null;
              }
              const isTicket = !s?.metadata?.indexName?.includes("kb");
              const ticketIdMatch = String(s.metadata?.id ?? '').match(/\d+/);
              const ticketId = isTicket && ticketIdMatch ? ticketIdMatch[0] : "";

              return (
                <div>
                  <Card>
                    <div className={styles.SourceTopbar}>
                      <Flex gap="2" align="center">
                        {s?.metadata?.indexName?.includes("kb") ? (
                          <FileTextIcon />
                        ) : (
                          <EnvelopeClosedIcon />
                        )}
                        <Text as="label" size={"5"}>
                          {isTicket
                            ? s.metadata.isGenerated
                              ? "Training Session"
                              : `Ticket #${ticketId}`
                            : s.metadata.title}
                        </Text>
                        {s.metadata.positiveFeedback === 1 ? (
                          <Badge color="green">Good Feedback</Badge>
                        ) : (
                          <Badge color="blue">Imported</Badge>
                        )}
                      </Flex>
                      {!disableForgetIt &&
                        s.metadata.positiveFeedback === 1 && (
                          <Button
                            variant="outline"
                            color="gray"
                            size="1"
                            onClick={() => {
                              forgetFeedback({
                                id: s.metadata.id,
                                tenant: workspace,
                                useCase: "tickets",
                              }).then(() => {
                                toast("Feedback forgotten");
                              });
                            }}
                          >
                            Forget it
                          </Button>
                        )}
                    </div>
                    <Separator size={"4"} />
                    <Text as="label" size={"2"}>
                      {isTicket ? s?.metadata?.answer : s?.metadata?.text}
                    </Text>
                  </Card>
                </div>
              );
            })}
        </div>
      </Dialog.Content>
    </Dialog>
  );
};
